import { useCallback, useEffect } from 'react';

import { toCSV } from 'utils/clickme';
import { EFFICIENCY_HEADERS } from 'utils/constants/admin';
import { FILE_DATE_FORMAT } from 'utils/constants/date';
import { formatDate } from 'utils/date';

import useTrls from 'hooks/translation/useTrls';

import InputWithMultiDatePicker from 'components/InputWithMultiDatePicker';

import EfficiencyTable from 'components/Admin/Reports/EfficiencyReport/EfficiencyTable';
import fetchEfficiency from 'components/Admin/Reports/EfficiencyReport/fetchEfficiency';
import ReportWrapper from 'components/Admin/Reports/ReportWrapper';

import { setEfficiencyDates } from 'store/models/efficiency';
import { useDispatch, useSelector } from 'store/utils';

const EfficiencyReport = () => {
    const { from, to, efficiencyData, isLoad } = useSelector((state) => state.efficiency);
    const dispatch = useDispatch();
    const trl = useTrls();

    const onClickCSV = useCallback(() => {
        const fileName = `efficiency_${formatDate(from, FILE_DATE_FORMAT)}_${formatDate(to, FILE_DATE_FORMAT)}.csv`;
        const efficiencyDataForCSV = Object.keys(efficiencyData).map((source) => ({
            source,
            ...efficiencyData[source],
        }));
        toCSV(fileName, efficiencyDataForCSV, EFFICIENCY_HEADERS, []);
    }, [efficiencyData, from, to]);

    useEffect(() => {
        dispatch(fetchEfficiency());
    }, [dispatch]);

    return (
        <ReportWrapper
            title={trl('admin.SectionTabs.efficiency')}
            filter={
                <InputWithMultiDatePicker
                    action={(from, to) => dispatch(setEfficiencyDates({ from, to }))}
                    from={from}
                    to={to}
                />
            }
            content={<EfficiencyTable />}
            isLoadContent={isLoad}
            onClickSearch={() => dispatch(fetchEfficiency())}
            onClickCSV={onClickCSV}
        />
    );
};

export default EfficiencyReport;
